// Provincias y departamentos donde vive cada usuario.
// Igual que server/lib/ubicacion.js. San Juan va primero y es la provincia por defecto
// (los perfiles creados antes de elegir provincia son todos de San Juan).

export const PROVINCIA_DEFECTO = 'San Juan';

export const DEPARTAMENTOS_POR_PROVINCIA = {
  'San Juan': ['Capital','Rivadavia','Santa Lucía','Chimbas','Rawson','Pocito','Caucete','Zonda','Ullum','Angaco','Albardón','San Martín','Sarmiento','Calingasta','Iglesia','Jáchal','Valle Fértil','25 de Mayo','9 de Julio','Otro'],
  'Mendoza': ['Capital','Godoy Cruz','Guaymallén','Las Heras','Luján de Cuyo','Maipú','Lavalle','San Martín','Junín','Rivadavia','Santa Rosa','La Paz','San Rafael','General Alvear','Malargüe','Tunuyán','Tupungato','San Carlos','Otro'],
  'San Luis': ['Juan Martín de Pueyrredón (Capital)','General Pedernera','Ayacucho','Belgrano','Chacabuco','Coronel Pringles','Gobernador Dupuy','Junín','Libertador General San Martín','Otro'],
  'La Rioja': ['Capital','Chilecito','Arauco','Castro Barros','Chamical','Coronel Felipe Varela','Famatina','General Ángel Vicente Peñaloza','General Belgrano','General Juan Facundo Quiroga','General Lamadrid','General Ortiz de Ocampo','General San Martín','Independencia','Rosario Vera Peñaloza','San Blas de los Sauces','Sanagasta','Vinchina','Otro'],
};

export const PROVINCIAS = Object.keys(DEPARTAMENTOS_POR_PROVINCIA);

// Texto para mostrar en tarjetas y perfiles: «Capital, Mendoza»
export function lugarDe(p) {
  if (!p?.departamento) return '';
  return `${p.departamento}, ${p.provincia || PROVINCIA_DEFECTO}`;
}
